import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { Home } from "./pages/Home";
import { Gallery } from "./pages/Gallery";
import { ProductDetail } from "./pages/ProductDetail";
import { About } from "./pages/About";
import { Reviews } from "./pages/Reviews";
import { Contacts } from "./pages/Contacts";
import { OrderPage } from "./pages/OrderPage";
import { FAQ } from "./pages/FAQ";
import { AdminLogin } from "./pages/admin/AdminLogin";
import { AdminLayout } from "./pages/admin/AdminLayout";
import { AdminDashboard } from "./pages/admin/AdminDashboard";
import { AdminProducts } from "./pages/admin/AdminProducts";
import { AdminContacts } from "./pages/admin/AdminContacts";
import { AdminReviews } from "./pages/admin/AdminReviews";
import { AdminContent } from "./pages/admin/AdminContent";
import { AdminMarketing } from "./pages/admin/AdminMarketing";
import { Toaster } from "@/components/ui/sonner";

// SEO Landing Pages - Latvian
import { SaderinasanasGredzeniRiga } from "./pages/seo/SaderinasanasGredzeniRiga";
import { DimantaGredzeniRiga } from "./pages/seo/DimantaGredzeniRiga";
import { DimantaAuskariRiga } from "./pages/seo/DimantaAuskariRiga";
import { JuvelierizstradajumiRiga } from "./pages/seo/JuvelierizstradajumiRiga";
import { GredzeniArDimantiem } from "./pages/seo/GredzeniArDimantiem";

// SEO Landing Pages - Russian
import { PomolvochnyeKolcaRiga } from "./pages/seo/PomolvochnyeKolcaRiga";
import { KolcoSBrilliantomRiga } from "./pages/seo/KolcoSBrilliantomRiga";
import { SergiSBrilliantamiRiga } from "./pages/seo/SergiSBrilliantamiRiga";
import { YuvelirnyeIzdeliyaRiga } from "./pages/seo/YuvelirnyeIzdeliyaRiga";
import { ObruchalnyeKolcaRiga } from "./pages/seo/ObruchalnyeKolcaRiga";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { authService } from "@/utils/auth";
import { initGoogleAnalytics } from "@/utils/analytics";
import { useEffect, useState } from "react";
import axios from "axios";
import "./i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProtectedRoute = ({ children }) => {
  return authService.isAuthenticated() ? children : <Navigate to="/admin/login" />;
};

function App() {
  const [gaLoaded, setGaLoaded] = useState(false);

  useEffect(() => {
    const loadGoogleAnalytics = async () => {
      try {
        const response = await axios.get(`${API}/seo-settings`);
        if (response.data.google_analytics_id) {
          initGoogleAnalytics(response.data.google_analytics_id);
          window.GA_MEASUREMENT_ID = response.data.google_analytics_id;
          setGaLoaded(true);
        }
      } catch (error) {
        console.error('Failed to load Google Analytics', error);
      }
    };
    loadGoogleAnalytics();
  }, []);

  return (
    <HelmetProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<><Navigation /><Home /><Footer /></>} />
            <Route path="/gallery" element={<><Navigation /><Gallery /><Footer /></>} />
            <Route path="/product/:id" element={<><Navigation /><ProductDetail /><Footer /></>} />
            <Route path="/about" element={<><Navigation /><About /><Footer /></>} />
            <Route path="/reviews" element={<><Navigation /><Reviews /><Footer /></>} />
            <Route path="/contacts" element={<><Navigation /><Contacts /><Footer /></>} />
            <Route path="/order" element={<><Navigation /><OrderPage /><Footer /></>} />
            <Route path="/faq" element={<><Navigation /><FAQ /><Footer /></>} />
            
            {/* SEO Landing Pages - Latvian */}
            <Route path="/saderinasnanas-gredzeni-riga" element={<><Navigation /><SaderinasanasGredzeniRiga /><Footer /></>} />
            <Route path="/dimanta-gredzeni-riga" element={<><Navigation /><DimantaGredzeniRiga /><Footer /></>} />
            <Route path="/dimanta-auskari-riga" element={<><Navigation /><DimantaAuskariRiga /><Footer /></>} />
            <Route path="/juvelierizstradajumi-riga" element={<><Navigation /><JuvelierizstradajumiRiga /><Footer /></>} />
            <Route path="/gredzeni-ar-dimantiem" element={<><Navigation /><GredzeniArDimantiem /><Footer /></>} />
            
            {/* SEO Landing Pages - Russian */}
            <Route path="/pomolvochnye-kolca-riga" element={<><Navigation /><PomolvochnyeKolcaRiga /><Footer /></>} />
            <Route path="/kolco-s-brilliantom-riga" element={<><Navigation /><KolcoSBrilliantomRiga /><Footer /></>} />
            <Route path="/sergi-s-brilliantami-riga" element={<><Navigation /><SergiSBrilliantamiRiga /><Footer /></>} />
            <Route path="/yuvelirnye-izdeliya-riga" element={<><Navigation /><YuvelirnyeIzdeliyaRiga /><Footer /></>} />
            <Route path="/obruchalnye-kolca-riga" element={<><Navigation /><ObruchalnyeKolcaRiga /><Footer /></>} />
            
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/admin/dashboard" />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="contacts" element={<AdminContacts />} />
              <Route path="reviews" element={<AdminReviews />} />
              <Route path="content" element={<AdminContent />} />
              <Route path="marketing" element={<AdminMarketing />} />
            </Route>
          </Routes>
          <Toaster position="top-center" />
          <WhatsAppButton />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
